// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o29HmxDr044myVnEL9MW{background:var(--background-primary-inverted-primary);border-right:1px solid var(--border-neutral-default);grid-template-rows:120px 1fr;width:min(100vw - 330px,366px);min-width:328px;height:100%;display:grid}.bjcIFvvUcc4ESPGFWgkj{grid-template-rows:1fr}@media (min-width:992px){.o29HmxDr044myVnEL9MW{width:420px}}@media (min-width:1920px){.o29HmxDr044myVnEL9MW{width:500px}}.rjn7XdfbRgYUJXaGTM8B{grid-template-rows:1fr max-content;display:grid;overflow:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `o29HmxDr044myVnEL9MW`,
	"wrap__loading": `bjcIFvvUcc4ESPGFWgkj`,
	"wrapLoading": `bjcIFvvUcc4ESPGFWgkj`,
	"messages": `rjn7XdfbRgYUJXaGTM8B`
};
export default ___CSS_LOADER_EXPORT___;
